  import React,  {useContext} from 'react';
  import { Drawer, List, ListItemButton, ListItemText, IconButton,  ListItemIcon, Collapse, ListItemAvatar, 
    Avatar, Box, Typography, Button, Divider } from '@mui/material';
  import { useNavigate, useLocation } from 'react-router-dom';
  import { styled, useTheme } from '@mui/material/styles';
  // import { UserContexto } from '../app';
  import { useState } from 'react';
  import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
  import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
  import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
  import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
  import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
  import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
  import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
  import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
  import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
  import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
  import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
  import HorizontalSplitRoundedIcon from '@mui/icons-material/HorizontalSplitRounded';
  import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
  import AddBoxIcon from '@mui/icons-material/AddBox';
  import FolderIcon from '@mui/icons-material/Folder';
  import ExpandLess from '@mui/icons-material/ExpandLess';
  import ExpandMore from '@mui/icons-material/ExpandMore';
  import TableRowsIcon from '@mui/icons-material/TableRows';
  import TableChartIcon from '@mui/icons-material/TableChart';
  import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
  import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
  import * as globalstyles from '../theme/global';
  import { iconStandard } from '../theme/global';
  import User from '../assets/js/user';
  import { UserContext } from '../assets/contexts/userContext';
  import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
  import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
 import PanoramaIcon from '@mui/icons-material/Panorama';


  // const SidebarList = styled(List)(({ theme }) => ({
  //   width: 250,
  //   backgroundColor: theme.palette.background.paper,
  // }));

  // const SidebarItem = styled(ListItemButton)(({ theme }) => ({
  //   '&.Mui-selected': {
  //     backgroundColor: theme.palette.action.selected,
  //   },
  // }));


  const DrawerHeader = styled('div')(({ theme, drawerWidth }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  }));

  const ColorButton = styled(Button)(({ theme }) => ({
    color:'#fff',
    backgroundColor: '#80B779',
    '&:hover': {
        color:'#50724c',
      backgroundColor: '#b9b99f',
    },
  }));

  const Sidebar = ({  open, drawerWidth, drawerCollapsedWidth, handleDrawerClose, handleDrawerOpen,
    formularios=[], }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout } = useContext(UserContext);

    // Solo mostramos si está logueado
  
    const [openSubmenuForms, setOpenSubmenuForms] = useState(false);
  const [openSubmenuArticles, setOpenSubmenuArticles] = useState(false);
  const [openSubmenuClients, setOpenSubmenuClients] = useState(false);
  const [openSubmenuReports, setOpenSubmenuReports] = useState(false);
  const [openSubmenuServices, setOpenSubmenuServices] = useState(false);
  const [openSubmenuCategories, setOpenSubmenuCategories] = useState(false);
  const [openSubmenuUsers, setOpenSubmenuUsers] = useState(false);
    const isAdmin = user.hasRole('admin');
    const employee = user.hasRole('employee');
    const theme = useTheme();

    if (!user.isLogged) return null;


  const normalize = str =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\s-]+/g, ' ');
  const filtered = formularios.filter(f =>
    !['unete a nosotras', 'sugerencias'].includes(normalize(f.nombre))
  );


  const getSidebarLinkProps = (path) => ({
    component: 'a',
    href: path,
    onClick: (event) => {
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      navigate(path);
    },
  });


    return (
      <Drawer
      variant="permanent"
      anchor="left"
      open={open}
      sx={{
        position: 'relative', 
        width: open ? drawerWidth : drawerCollapsedWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: open ? drawerWidth : drawerCollapsedWidth,
          boxSizing: 'border-box',
          transition: 'width 0.3s ease',
          overflowX: 'hidden', // Evita scroll horizontal
          backgroundColor: theme.palette.primary.dark,
          boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2)',
        },
      }}
    >
    
            {/* Botón para cerrar Sidebar */}
        <DrawerHeader sx={{backgroundColor: theme.palette.primary.dark, display: 'flex', flexDirection: 'column',  justifyContent: 'space-between', alignItems: 'center', }}>

        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1,justifyContent: open ? 'space-around' : 'center',  width: '100%', alignItems: 'center', marginBottom: open ? '10px' : '0px',}}>
          { user.avatar ? <Avatar  variant="rounded" src={user.avatar} sx={{width: open ? '80px' : '35px', height: open ? '80px' : '35px',   alignSelf:'center', m: open ? 0 : 1}}/> : <Avatar  variant="rounded" sx={{width: open ? '80px' : '35px', height: open ? '80px' : '35px', marginTop: open ? '20px' : '0', marginBottom: open ? '0' : '20px', alignSelf:'center', }}>{user.name.charAt(0)}</Avatar>}
          { open ? <Typography variant="body1" sx={{color:'#fff', alignSelf:'center', }}>{`${user.name} ${user.lastName ?? ''}`}</Typography> : null}
        </Box>
       <Divider sx={{backgroundColor: '#fff', color: '#fff', width: '100%', }}/>

        <Box sx={{display: 'flex', alignItems: 'center',justifyContent: 'space-between', width: '100%', }}>
        { open ? <ListItemText sx={{color:'#fff', padding: open ? '8px 16px' : '8px',}} primary="Menú" /> : null}
        <ListItemButton sx={{ gap: '0.5em', 
                justifyContent: open ? 'flex-end' : 'center', // Centra cuando está cerrado
                padding: open ? '10px 16px' : '8px',
                backgroundColor: 'transparent',
                '&:hover': {
                  backgroundColor: 'transparent',
                } }}
                onClick={open? handleDrawerClose : handleDrawerOpen}
                >   
              {open ? 
              <Box
                component="span"
                sx={{
                  p: 0.5,                   // relleno alrededor de la flecha
                  borderRadius: '20%',    // fondo redondeado
                  '&:hover': {
                    bgcolor: '#fff',   // color de fondo al pasar el ratón
                  },
                  '&:hover .MuiSvgIcon-root': {
                  color: '#405b3c',
                },
                }}
              >
              <ArrowBackIosRoundedIcon sx={{...globalstyles.iconSidebar, 
              marginLeft: '0',
              fontSize: 'larger',
                '&:hover': {
              color:'#405b3c',
              //backgroundColor: '#fff',
              borderRadius: '20%',
              transition: 'background-color 0.3s ease',
              }
              }} />
              </Box> : 
              <Box
                component="span"
                sx={{
                p: 0.5,                      // relleno alrededor de la flecha
                  borderRadius: '20%',    // fondo redondeado
                  '&:hover': {
                    bgcolor: '#fff',   // color de fondo al pasar el ratón
                  },
                    '&:hover .MuiSvgIcon-root': {
                  color: '#405b3c',
                },
                }}
              >
              <ArrowForwardIosRoundedIcon 
              sx={{...globalstyles.iconSidebar, 
              marginLeft: '0',
              fontSize: 'larger',
                '&:hover': {
              color:'#405b3c',
             //backgroundColor: '#fff',
              borderRadius: '20%',
              transition: 'background-color 0.3s ease',
              }
              }} 
            /></Box>}
        </ListItemButton> 
        </Box>
        </DrawerHeader>

        <List sx={{color:'#fff', marginLeft: 0, padding: 0}}>
          {isAdmin ? (
            <>
            
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/adminDashboard')}
                selected={location.pathname === '/admin/adminDashboard'}>
              <DashboardRoundedIcon  sx={globalstyles.iconSidebar}/>         
                {open ? <ListItemText primary="Panel Admin" sx={{ 
                  fontWeight: '500',
                }}/> : null}
              </ListItemButton>
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/pages/profile')}
                selected={location.pathname === '/pages/profile'}>
              <AccountCircleRoundedIcon sx={globalstyles.iconSidebar}/>         
                {open ? <ListItemText primary="Perfil" /> : null}
              </ListItemButton>
              
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/roles')}
                selected={location.pathname.startsWith('/admin/roles')}>
                <SecurityRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Roles" /> : null}
              </ListItemButton>
            
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/pages/calendar')}
                selected={location.pathname === '/pages/calendar'}>
                <CalendarMonthRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Calendario" /> : null}
              </ListItemButton>

              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageActivities')}
                selected={location.pathname.startsWith('/admin/manageActivities')}>
                <EventAvailableRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Actividades" /> : null}
              </ListItemButton>

              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/disponibilidad')}
                selected={location.pathname === '/employee/disponibilidad'}>
                <AccessTimeRoundedIcon  sx={globalstyles.iconSidebar}/>
                {open ? <ListItemText primary="Disponibilidad" /> : null}
              </ListItemButton>
              {/* <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/createForm')}>
                <HorizontalSplitRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Formulario" /> : null}
              </ListItemButton> */}

              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageMedia')}
                selected={location.pathname.startsWith('/admin/manageMedia')}>
                <PanoramaIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Gestión Multimedia" /> : null}
              </ListItemButton>

       
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageFormations')}
                selected={location.pathname.startsWith('/admin/manageFormations')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Formaciones" /> : null}
              </ListItemButton>

                {/* <ListItemButton 
                onClick={() => setOpenSubmenuUsers(!openSubmenuUsers)} 
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Usuarios"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Usuarios" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuUsers ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton> */}

                  {/* <Collapse in={openSubmenuUsers} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding> */}
                      
                     {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                        {...getSidebarLinkProps('/admin/registro')}
                        selected={location.pathname.startsWith('/admin/registro')}>
                        <PersonAddAltRoundedIcon sx={globalstyles.iconSidebar} />
                        {open ? <ListItemText primary="Registrar usuario" /> : null}
                      </ListItemButton>  */}

                    <ListItemButton
                    //  sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                     sx={globalstyles.listItemButtonSidebar(open)}
                      {...getSidebarLinkProps('/admin/usuarios')}
                      selected={location.pathname.startsWith('/admin/usuarios')}>
                      <PeopleAltRoundedIcon  sx={globalstyles.iconSidebar}/>
                      {open ? <ListItemText primary="Usuarios" /> : null}
                    </ListItemButton>
{/* 
                    </List>
                  </Collapse> */}





                  {/* <ListItemButton 
                onClick={() => setOpenSubmenuForms(!openSubmenuForms)} 
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Formularios"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Formularios" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuForms ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

                  <Collapse in={openSubmenuForms} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding> */}
                      
                      {/* Si aún quieres tus opciones fijas de "Crear" o "respuestas": */}
                      {/* <ListItemButton
                        sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                        {...getSidebarLinkProps('/pages/createForm')}
                        selected={location.pathname.startsWith('/pages/createForm')}
                      >
                         <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                        {open && <ListItemText primary="Crear Formulario" />}
                      </ListItemButton> */}
 
                      <ListItemButton
                      //  sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                       sx={globalstyles.listItemButtonSidebar(open)}
                        {...getSidebarLinkProps('/admin/manageForms')}
                        selected={location.pathname.startsWith('/admin/manageForms')}
                      >
                        <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                        {open && <ListItemText primary="Formularios" />}
                      </ListItemButton>         

                    {/* </List> 
                  </Collapse> */}



                  {/* <ListItemButton 
                onClick={() => setOpenSubmenuArticles(!openSubmenuArticles)} 
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Artículos"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Artículos" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuArticles ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuArticles} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/blog/createArticle')}
                selected={location.pathname === '/blog/createArticle'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Artículo" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageArticles')}
                selected={location.pathname.startsWith('/admin/manageArticles')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Artículos" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}



               {/* <ListItemButton 
                onClick={() => setOpenSubmenuClients(!openSubmenuClients)} 
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Clientes"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Clientes" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuClients ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuClients} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/admin/createClient')}
                selected={location.pathname === '/admin/createClient'}>
                <PersonAddAltRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Cliente" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageClients')}
                selected={location.pathname.startsWith('/admin/manageClients') || location.pathname.startsWith('/admin/clinicalHistory')}>
                <PeopleAltRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Clientes" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}


               {/* <ListItemButton
                onClick={() => setOpenSubmenuReports(!openSubmenuReports)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Informes"
                    sx={globalstyles.iconSidebar}
                      />
                {open ? <ListItemText primary="Informes"
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuReports ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuReports} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/admin/createReport')}
                selected={location.pathname === '/admin/createReport'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Informe" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageReports')}
                selected={location.pathname.startsWith('/admin/manageReports') || location.pathname.startsWith('/admin/createReport')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Informes" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}


               {/* <ListItemButton
                onClick={() => setOpenSubmenuServices(!openSubmenuServices)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>


                      <FolderIcon alt="Servicios"
                    sx={globalstyles.iconSidebar}
                      />
                {open ? <ListItemText primary="Servicios"
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuServices ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuServices} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/admin/createService')}
                selected={location.pathname === '/admin/createService'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Servicio" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageServices')}
                selected={location.pathname.startsWith('/admin/manageServices')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Servicios" /> : null}
              </ListItemButton>

            
{/*               
              </List>
               </Collapse> */}

               {/* <ListItemButton
                onClick={() => setOpenSubmenuCategories(!openSubmenuCategories)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>


                      <FolderIcon alt="Categorías"
                    sx={globalstyles.iconSidebar}
                      />
                {open ? <ListItemText primary="Categorías"
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuCategories ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuCategories} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/admin/createCategory')}
                selected={location.pathname === '/admin/createCategory'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Categoría" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/admin/manageCategories')}
                selected={location.pathname.startsWith('/admin/manageCategories')}>
                <FormatListBulletedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Categorías" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}

                <Divider sx={{ backgroundColor: '#fff', color: '#fff', m: 1 }} />

               <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), mb:2}}
                // onClick={handleLogout}
                onClick={() => { navigate('/', { replace: true }); logout(); }}
                >
              <ExitToAppRoundedIcon  sx={globalstyles.iconSidebar}/>
                {open ? <ListItemText primary="Cerrar sesión" /> : null}
              </ListItemButton>
              
            </>


          ) : employee ? (


            <>
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)} 
              {...getSidebarLinkProps('/employee/employeeDashboard')}>
                <DashboardRoundedIcon sx={{
              marginLeft: '0',
              '&:hover': {
              color:'#405b3c',
              // backgroundColor: '#fff',
              borderRadius: '50%',
              transition: 'background-color 0.3s ease',
            },
              }}/>  
                {open ? <ListItemText primary="Panel Empleado" /> : null}
              </ListItemButton>
              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)} 
                {...getSidebarLinkProps('/pages/profile')}>   
              <AccountCircleRoundedIcon  sx={globalstyles.iconSidebar}/>         
                {open ? <ListItemText primary="Perfil" /> : null}
              </ListItemButton>

              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/citas')}>
                <CalendarMonthRoundedIcon  sx={globalstyles.iconSidebar}/>
                {open ? <ListItemText primary="Mis Citas" /> : null}
              </ListItemButton>

              <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/disponibilidad')}>
                <AccessTimeRoundedIcon  sx={globalstyles.iconSidebar}/>
                {open ? <ListItemText primary="Disponibilidad" /> : null}
              </ListItemButton>

              {/* <ListItemButton sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/clientes')}>
                <PeopleAltRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Mis Clientes" /> : null}
              </ListItemButton> */}


              {/* <ListItemButton
                onClick={() => setOpenSubmenuForms(!openSubmenuForms)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Formularios"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Formularios" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuForms ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

                  <Collapse in={openSubmenuForms} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                       */}
                      {/* Si aún quieres tus opciones fijas de "Crear" o "respuestas": */}
                      {/* <ListItemButton
                       sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                        {...getSidebarLinkProps('/pages/createForm')}
                        selected={location.pathname.startsWith('/pages/createForm')}
                      >
                         <ListItemIcon sx={{ minWidth: 0, mr: open ? 2 : 0 }}>
                   
                           <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                        </ListItemIcon>
                        {open && <ListItemText primary="Crear Formulario" />}
                      </ListItemButton> */}
 
                      <ListItemButton
                      // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                       sx={globalstyles.listItemButtonSidebar(open)}
                        {...getSidebarLinkProps('/employee/forms')}
                        selected={location.pathname.startsWith('/employee/forms')}
                      >
                     
                        <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                
                        {open && <ListItemText primary="Formularios" />}
                      </ListItemButton>    
                                     
                    {/* </List> 
                  </Collapse> */}

            

                  {/* <ListItemButton
                onClick={() => setOpenSubmenuArticles(!openSubmenuArticles)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Artículos"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Artículos" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuArticles ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuArticles} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/blog/createArticle')}
                selected={location.pathname === '/blog/createArticle'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Artículo" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/articles')}
                selected={location.pathname.startsWith('/employee/articles')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Artículos" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}

                

               {/* <ListItemButton
                onClick={() => setOpenSubmenuClients(!openSubmenuClients)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Clientes"
                    sx={globalstyles.iconSidebar}
                      />          
                {open ? <ListItemText primary="Clientes" 
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuClients ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuClients} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/employee/createClient')}
                selected={location.pathname === '/employee/createClient'}>
                <PersonAddAltRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Cliente" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/clientes')}
                selected={location.pathname.startsWith('/employee/clientes')}>
                <PeopleAltRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Clientes" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}


              {/* <ListItemButton
                onClick={() => setOpenSubmenuReports(!openSubmenuReports)}
                  sx={globalstyles.listItemButtonSidebarSubmenu(open)}>

                      <FolderIcon alt="Informes"
                    sx={globalstyles.iconSidebar}
                      />
                {open ? <ListItemText primary="Informes"
                sx={{color:'#fff',
                }}
                /> : null}
                {openSubmenuReports ? (
                  <ExpandLess sx={iconStandard(theme)} />
                ) : (
                  <ExpandMore sx={iconStandard(theme)} />
                )}
                  </ListItemButton>

              <Collapse in={openSubmenuReports} timeout="auto" unmountOnExit>
              <List component="div" disablePadding> */}
              {/* <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
                {...getSidebarLinkProps('/employee/createReport')}
                selected={location.pathname === '/employee/createReport'}>
                <PostAddRoundedIcon  sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Crear Informe" /> : null}
              </ListItemButton> */}

              <ListItemButton 
              // sx={{...globalstyles.listItemButtonSidebar(open), marginX: open ? 1.2 : 0.5 }}
               sx={globalstyles.listItemButtonSidebar(open)}
                {...getSidebarLinkProps('/employee/reports')}
                selected={location.pathname.startsWith('/employee/reports')}>
                <ArticleRoundedIcon sx={globalstyles.iconSidebar} />
                {open ? <ListItemText primary="Informes" /> : null}
              </ListItemButton>
              {/* </List>
               </Collapse> */}


               <Divider sx={{ backgroundColor: '#fff', color: '#fff', m: 1 }} />


               <ListItemButton sx={{...globalstyles.listItemButtonSidebar(open), mb:2}} 
                // onClick={handleLogout}
                onClick={() => { navigate('/', { replace: true }); logout(); }}
                >   
              <ExitToAppRoundedIcon  sx={globalstyles.iconSidebar}/>         
                {open ? <ListItemText primary="Cerrar sesión" /> : null}
              </ListItemButton>


            </>
          ) : null}
        </List>
      </Drawer>
    );
  };

  export default Sidebar;


